import { Box, Typography } from '@mui/material';
import { ChangelogItem } from '../../types/Changelog/ChangelogItem.type.ts';
import { getChangelogTypeStyle } from '../../utils/changelogTypeStyle.ts';

const ChangelogItemComponent = ({ changelogItem }: { changelogItem: ChangelogItem }) => {
  const changelogTypeBadgeStyle = getChangelogTypeStyle(changelogItem.type_id);
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, marginBottom: 0.5 }}>
        <Typography variant='h6' sx={{ color: 'primary.main', fontSize: '18px', fontWeight: 700 }}>
          {changelogItem.title}
        </Typography>
        <Box
          component='span'
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            paddingX: 1,
            paddingY: '1px',
            borderRadius: '6px',
            border: `1px solid ${changelogTypeBadgeStyle.borderColor}`,
            color: changelogTypeBadgeStyle.color,
            fontSize: '12px',
            fontWeight: 500,
          }}
        >
          {changelogTypeBadgeStyle.name}
        </Box>
      </Box>
      <Typography sx={{ color: 'text.secondary', fontSize: '14px' }}>{changelogItem.description}</Typography>
    </Box>
  );
};

export default ChangelogItemComponent;
